import { Box } from '@quintoandar-tokko/jopijs';
import RowName from '../components/RowName';
import ProgressBar from '../components/ProgressBar';
import ItemCount from '../components/ItemCount';
import PercentageValue from '../components/PercentageValue';
import styles from './pendingScheduledEvents.module.scss';

export default function PendingScheduledEventRow({
  stats = {
    text: '',
    count: '',
    percentage: '',
  },
  className = '',
  onClick,
  children,
  ...rest
}) {
  const wrapperClassNames = `${styles.rowWrapper} ${className}`;
  const classNames = `${
    onClick ? styles.pendingScheduledEventsRowClickable : ''
  } ${styles.pendingScheduledEventsRow} ${className}`;

  return (
    <Box className={wrapperClassNames}>
      <Box className={classNames} onClick={onClick} {...rest}>
        <RowName text={stats.text} />
        <ProgressBar percentage={stats.percentage} />
        <ItemCount icon="icon-contactos" value={stats.count} />
        <PercentageValue percentage={stats.percentage} />

        {children}
      </Box>
    </Box>
  );
}
